<template>
  <div class="activity-detail-container">
    <div class="activity-detail-header">
      <div class="activity-title">
        <div class="activity-title__icon"></div>
        <div class="activity-title__text">{{ detail.activityInfo.title }}</div>
        <div class="activity-title__status-tag" :class="[`status-${detail.activityInfo.status}`]">
          {{ detail.activityInfo.status | statusFilter }}
        </div>
      </div>
      <div class="activity-time">活动时间：{{ detail.activityInfo.startTime | timeFilter }} 至 {{ detail.activityInfo.endTime | timeFilter }}</div>
    </div>
    <Tabs :animated="false">
      <TabPane label="活动详情">
        <div class="activity-container">
          <div class="wrap">
            <div class="wrap-title">规则详情</div>
            <div class="wrap-content">
              <template v-if="detail.activityInfo.type == 2">
                <table class="rule-table">
                  <colgroup>
                    <col style="width: 33%;" />
                    <col style="width: 33%;" />
                    <col style="width: 34%;" />
                  </colgroup>
                  <thead>
                    <tr class="big-title">
                      <th colspan="3">
                        <div class="rule-title">条件指标：{{ detail.activityInfo.conditionRule | conditionRuleFilter }}</div>
                        <div class="rule-sub-title">*条件指标是保单达到相应梯度的具体保费条件</div>
                      </th>
                    </tr>
                    <tr class="sub-title">
                      <th>条件指标最小值(美元)</th>
                      <th>条件指标最大值(美元)</th>
                      <th v-if="detail.activityInfo.rewardType == 1">奖励(%)</th>
                      <th v-if="detail.activityInfo.rewardType == 2">奖励(港币)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(g, idx) in detail.gradientList" :key="idx">
                      <td>{{ g.min }}</td>
                      <td>{{ g.max }}</td>
                      <td>{{ g.reward | rewardFilter(detail.activityInfo.rewardType) }}</td>
                    </tr>
                    <tr v-if="!detail.gradientList || (detail.gradientList && !detail.gradientList.length)">
                      <td colspan="3">暂无数据</td>
                    </tr>
                  </tbody>
                </table>
                <div class="rule-table-desc">
                  *以上最小值包含当前数字，最大值不包含
                </div>
              </template>
              <div class="rule-text">
                {{ detail.activityInfo.settlementRule || '-' }}
              </div>
            </div>
          </div>
          <div class="wrap">
            <div class="wrap-title">{{ detail.activityInfo.type == 1 ? '参与产品与奖励详情' : '参与产品' }}</div>
            <div class="wrap-content">
              <Table class="product-table" size="small" :columns="productTableColumns" :span-method="spanMethod" :data="detail._activityProducts" />
            </div>
          </div>
        </div>
      </TabPane>
      <TabPane label="参与详情">
        <div class="part-container">
          <Button class="part-btn-export" type="primary" ghost @click="handleExport">导出</Button>
          <div class="wrap">
            <div class="part-desc">
              *活动奖励与奖励积分以最终结算为准
            </div>
            <div class="part-stats">
              共计保单{{ statsData.policyNum }}单，美元规保/标保：{{ statsData.usdFee }} / {{ statsData.usdFyb }}，港币规保/标保：{{ statsData.hkdFee }} /
              {{ statsData.hkdFyb }}，人民币规保/标保：{{ statsData.cnyFee }} / {{ statsData.cnyFyb }}
            </div>
            <div>
              <loading :isShow="listLoading" />
              <Table class="part-table" :columns="partTableColumns" :data="partData" />
              <div style="padding-top: 30px;padding-bottom: 20px;">
                <Page
                  :total="total"
                  :current="pageNum"
                  :page-size="pageSize"
                  :page-size-opts="[10, 20, 30, 50, 100]"
                  show-total
                  show-sizer
                  transfer
                  style="text-align: center"
                  @on-change="getList"
                  @on-page-size-change="(pageSize = $event), getList()"
                />
              </div>
            </div>
          </div>
        </div>
      </TabPane>

      <template slot="extra">
        <div style="padding-right: 40px;">
          <Button type="primary" ghost @click="handleBack">返回</Button>
        </div>
      </template>
    </Tabs>
  </div>
</template>

<script>
import { common, pageTool } from '@/api/mixins';
import dayjs from 'dayjs';
import Decimal from 'decimal.js';

const dic = JSON.parse(localStorage.dic);
const CURRENCY_TYPE = dic['CURRENCY_TYPE'];
const POLICY_STATUS = dic['POLICY_STATUS'];

export default {
  mixins: [common, pageTool],
  data() {
    return {
      detail: {
        activityInfo: {},
        activityProducts: [],
        gradientList: []
      },
      productTableColumns: [],
      partTableColumns: [],
      partData: [],
      statsData: {},
      spanMethod: ({ row, column, rowIndex, columnIndex }) => {
        // if (!this.isShowAgeCol) {
        //   return [1, 1];
        // }

        if (column.key === 'productName') {
          if (row._apRowSpan) {
            return [row._apRowSpan, 1];
          } else {
            return [0, 0];
          }
        }

        if (column.key === '_age') {
          if (row._ageRowSpan) {
            return [row._ageRowSpan, 1];
          } else {
            return [0, 0];
          }
        }

        return [1, 1];
      }
    };
  },
  filters: {
    timeFilter(time) {
      if (!time) return '-';
      return dayjs(time).format('YYYY-MM-DD');
    },
    statusFilter(status) {
      if (status == '1') return '进行中';
      if (status == '2') return '已结束';
      return '-';
    },
    rewardFilter(reward, rT) {
      if (!rT) {
        return '-';
      }
      if (rT == 1 && reward) {
        return new Decimal(reward).mul(100).toNumber();
      } else {
        return reward;
      }
    },
    conditionRuleFilter(t) {
      if (t == '1') return '保单规保';
      if (t == '2') return '保单标保';
      if (t == '3') return '累计规保';
      if (t == '4') return '累计标保';
      return '-';
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.getProductTableColumns();
    this.getPartColumns();
    this.initListAjax('/buz/activity/read/policy/list');
  },
  activated() {
    this.getDetailData();
    // this.getPolicyDetailData();
    this.getStatsData();
    this.getProductTableColumns();
    this.getPartColumns();
    this.getList();
  },
  methods: {
    handleBack() {
      this.back(this.$route.query.backUrl);
    },
    getProductTableColumns() {
      let columns = [
        {
          title: '产品名称',
          key: 'productName',
          align: 'center',
          render(h, params) {
            return h('div', `${params.row.productName} (${params.row.companyName})`);
          }
        },
        {
          title: '受保人年龄',
          key: '_age',
          align: 'center'
        },
        {
          title: '缴费年限',
          key: 'paymentPeriod',
          align: 'center'
        }
      ];
      if (this.detail.activityInfo.type == '1') {
        // 限时加佣
        columns.push({
          title: '奖励（%）',
          key: 'firstCommission',
          align: 'center',
          render(h, params) {
            const n = new Decimal(params.row.firstCommission).mul(100).toNumber();
            return h('div', n);
          }
        });
      }

      this.productTableColumns = columns;
    },
    getPartColumns() {
      let columns = [
        {
          title: '保单编号',
          key: 'policyNo',
          align: 'center',
          minWidth: 120
        },
        {
          title: '产品名称',
          key: 'productName',
          align: 'center',
          minWidth: 120
        },
        {
          title: '受保人年龄',
          key: 'insuranceAge',
          align: 'center',
          width: 120
        },
        {
          title: '缴费年限',
          key: 'period',
          align: 'center',
          width: 100
        },
        {
          title: '规模保费',
          key: 'fee',
          align: 'center',
          width: 140,
          render(h, params) {
            const fee = params.row.fee;
            const suffix = CURRENCY_TYPE[params.row.currencyType] || '';
            return h('div', [h('span', { style: { marginRight: '4px' } }, fee), h('span', suffix)]);
          }
        }
        // {
        //   title: '出单货币',
        //   key: 'currencyType',
        //   align: 'center',
        //   width: 100,
        //   render(h, params) {
        //     return h('div', CURRENCY_TYPE[params.row.currencyType] || '-');
        //   }
        // }
      ];
      const c = this.detail.activityInfo;
      if (c.type == '2' && [2, 4].includes(c.conditionRule * 1)) {
        // 保单标保、累计标保
        columns.push({
          title: '标准保费',
          key: 'fyb',
          align: 'center',
          width: 140,
          render(h, params) {
            const fyb = params.row.fyb;
            const suffix = CURRENCY_TYPE[params.row.currencyType] || '';
            return h('div', [h('span', { style: { marginRight: '4px' } }, fyb), h('span', suffix)]);
          }
        });
      }
      if (c.type == '1' || (c.type == '2' && [1, 2].includes(c.conditionRule * 1))) {
        // 梯度
        if (c.type == '1' || c.rewardType == '1') {
          // 加佣
          columns.push({
            title: '活动奖励',
            key: 'activityBonus',
            align: 'center',
            width: 120
          });
        }
        columns.push({
          title: '奖励积分',
          key: 'bonusAmount',
          align: 'center',
          width: 120
        });
      }

      columns.push(
        {
          title: '签单日期',
          key: 'signDate',
          align: 'center',
          width: 120
        },
        {
          title: '生效日期',
          key: 'effectiveDate',
          align: 'center',
          width: 120
        },
        {
          title: '保单状态',
          key: 'policyStatus',
          align: 'center',
          width: 100,
          render(h, params) {
            return h('div', POLICY_STATUS[params.row.policyStatus] || '-');
          }
        }
      );
      this.partTableColumns = columns;
    },
    getStatsData() {
      this.$http({
        url: '/buz/activity/policy/statistics',
        type: 'POST',
        data: {
          activityId: this.id
        }
      }).then(res => {
        this.statsData = res.data;
      });
    },
    handleExport() {
      this.$units.downloadFile(
        '/buz/activity/policy/export',
        {
          id: this.id
        },
        'GET'
      );
    },
    setListParams(params) {
      params.activityId = this.id;
    },
    // getPolicyDetailData() {
    //   this.$http({
    //     url: '/buz/activity/read/policy/list',
    //     type: 'GET',
    //     data: {
    //       id: this.id
    //     }
    //   }).then(res => {
    //     this.partData = res.data;
    //   });
    // },
    listCallback(res) {
      this.partData = res.data;
    },
    getDetailData() {
      this.$http({
        url: '/buz/activity/read/detail',
        type: 'GET',
        data: {
          id: this.id
        }
      }).then(res => {
        const detail = res.data;
        let _activityProducts = [];
        let _tempAps = [];
        let isShowAgeCol = false;
        detail.activityProducts.forEach(ap => {
          _tempAps = [];
          if (ap.productRule) {
            const _productRule = JSON.parse(ap.productRule);
            const _ap = JSON.parse(JSON.stringify(ap));
            delete _ap.productRule;
            ap._productRule = _productRule;
            const _ageObj = {};
            _productRule.forEach(pr => {
              pr._age = pr.age;
              if (/[0-9]/.test(pr.age)) {
                isShowAgeCol = true;
                pr._age += '岁';
              } else {
                pr._age = pr.age || '--';
              }
              if (!_ageObj[pr.age]) {
                _ageObj[pr.age] = [];
              }
              _ageObj[pr.age].push(pr);
            });
            const _ageKeys = Object.keys(_ageObj);
            _ageKeys.sort();
            const _sortedAgeArr = [];
            _ageKeys.forEach(key => {
              _ageObj[key].sort((a, b) => {
                return a.paymentPeriod - b.paymentPeriod;
              });
              _ageObj[key][0]._ageRowSpan = _ageObj[key].length;
              _ageObj[key].forEach(item => {
                _sortedAgeArr.push(item);
              });
            });
            _sortedAgeArr.forEach(pr => {
              const r = {
                _idx: _activityProducts.length + _tempAps.length,
                ..._ap,
                ...pr
              };
              _tempAps.push(r);
            });
            _tempAps[0]._apRowSpan = _tempAps.length;
            _activityProducts = _activityProducts.concat(_tempAps);
          }
        });
        if (!_activityProducts.length) {
          _activityProducts = detail.activityProducts.map(item => {
            item._apRowSpan = 1;
            item._ageRowSpan = 1;
            item._age = '--';
            item.paymentPeriod = '-';
            return item;
          });
        }
        this.isShowAgeCol = isShowAgeCol;
        console.log('_activityProducts', JSON.parse(JSON.stringify(_activityProducts)));
        detail._activityProducts = _activityProducts;
        this.detail = detail;
        this.getProductTableColumns();
        this.getPartColumns();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.activity-detail-container {
  font-family: 'PingFang SC';
  /deep/.ivu-tabs-nav-scroll {
    padding-left: 30px;
  }
  .activity-detail-header {
    padding-left: 30px;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .activity-title {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }
  .activity-title__icon {
    height: 18px;
    width: 18px;
    background-image: url(./clock.png);
    background-size: contain;
    margin-right: 6px;
  }
  .activity-title__text {
    height: 22px;
    line-height: 22px;
    font-weight: 500;
    font-size: 16px;
    color: #3c464f;
    margin-right: 6px;
  }
  .activity-title__status-tag {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 24px;
    border-radius: 4px;
    padding: 0 9px;
    font-weight: 400;
    font-size: 14px;
    border-width: 1px;
    border-style: solid;

    &.status-1 {
      border-color: #b7ea8f;
      background: #f6ffec;
      color: #51c419;
    }

    &.status-2 {
      background: rgba(114, 124, 142, 0.08);
      border-color: rgba(114, 124, 142, 0.08);
      color: #727c8e;
    }
  }
  .activity-time {
    height: 18px;
    line-height: 18px;
    font-weight: 400;
    font-size: 13px;
    color: #515c6f;
  }
}
.activity-container,
.part-container {
  padding-bottom: 100px;
  padding-left: 30px;
  position: relative;
}

.part-desc {
  height: 16px;
  font-weight: 400;
  font-size: 12px;
  color: #727c8e;
  line-height: 18px;
}

.part-stats {
  margin-top: 14px;
  height: 18px;
  font-weight: 400;
  font-size: 14px;
  color: #3c464f;
  line-height: 18px;
}

.part-table,
.product-table {
  margin-top: 12px;

  /deep/ table {
    th {
      border-color: #e3e5e8;
    }
  }

  /deep/.ivu-table-cell {
    font-family: 'PingFang SC';
    font-weight: 400;
    font-size: 12px;
    color: #515c6f;
  }
}

.part-btn-export {
  width: 100px;
  position: absolute;
  right: 40px;
  top: 0;
  z-index: 9;
  background: #fff;
  color: #236dff;
  border: 1px solid #236dff;
}

.wrap {
  margin-top: 20px;
  color: #3c464f;
  max-width: 1270px;
  position: relative;

  .wrap-title {
    position: relative;
    align-items: center;
    display: flex;
    height: 20px;
    padding-left: 10px;
    font-weight: 500;
    font-size: 14px;

    &::before {
      content: '';
      position: absolute;
      top: 50%;
      margin-top: -6px;
      left: 0;
      width: 4px;
      height: 12px;
      background: #236dff;
      border-radius: 100px;
    }
  }

  .rule-text {
    margin-top: 7px;
    white-space: pre-line;
    word-break: break-all;
    font-size: 12px;
  }

  .rule-table {
    width: 100%;
    border: 1px solid #e3e5e8;
    margin-top: 17px;
    th,
    td {
      height: 38px;
      text-align: center;
      border: 1px solid #e3e5e8;
    }
    .big-title {
      th {
        height: initial;
        padding: 14px 0;
      }

      .rule-title {
        height: 17px;
        font-weight: 500;
        font-size: 12px;
        color: #3c464f;
        line-height: 17px;
      }

      .rule-sub-title {
        margin-top: 4px;
        height: 16px;
        font-weight: 400;
        font-size: 12px;
        color: #727c8e;
        line-height: 18px;
      }
    }
    .sub-title {
      th {
        font-size: 12px;
      }
    }
    tbody {
      td {
        font-family: 'PingFang SC';
        font-weight: 400;
        font-size: 12px;
        color: #515c6f;
      }
    }
  }
  .rule-table-desc {
    margin-top: 14px;
    height: 16px;
    font-weight: 400;
    font-size: 12px;
    color: #727c8e;
    line-height: 18px;
  }
}
</style>
